export default "__VITE_ASSET__a298610a__"